var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Notice Notice--info is-loading"},[_c('h2',{staticClass:"Notice-header"},[_vm._v("\n    Your dashboard is being initialised.\n  ")]),_vm._v(" "),_c('p',{staticClass:"Notice-copy"},[_vm._v("\n    Please wait a moment...\n  ")])])
}]

export { render, staticRenderFns }